import React, { useEffect } from 'react';
import { TilesContainer } from './Tiles.styles';
import { getAppContentConfiguration } from '../../hooks/tileHook';
import { scrollToPreviouslySelectedVehicle, useServicesContext } from '@oneaudi/vtp-shared';
import { TrackingServiceV2 } from '@oneaudi/audi-tracking-service';
import { trackFeatureAppReady } from '../../tracking/tilesTracking';

const Tiles: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const { detailsPageUrlPattern, filterCategories, isNewCarsPage, appContext } =
    getAppContentConfiguration();
  const detailsURL = detailsPageUrlPattern ?? '';

  const trackingService = useServicesContext().getAdditionalService(
    'audi-tracking-service'
  ) as TrackingServiceV2;

  // check after rendering if user was coming back to the page
  // and try to scoll to that position
  useEffect(() => {
    if (typeof globalThis.plpInitialized === 'undefined') {
      globalThis.plpInitialized = true;
    } else {
      return;
    }
    scrollToPreviouslySelectedVehicle();

    trackFeatureAppReady(trackingService, isNewCarsPage, filterCategories);
  }, []);

  return (
    <TilesContainer
      data-testid="TilesContainer"
      className="sc-result-items"
      data-details-url={detailsURL}
      appContext={appContext}
    >
      <>{children}</>
    </TilesContainer>
  );
};

export default Tiles;
